import React, { createContext, useContext, useMemo } from "react";
import {
  FORM_FIELD_MARKS,
  resolveFieldMarks,
  type FieldMarks,
  type ResolvedFieldMarks,
} from "@eaco/forms-core";

const FieldMarksContext = createContext<ResolvedFieldMarks>(FORM_FIELD_MARKS);

/**
 * What the document says about its field marks, over the host's defaults.
 * DocumentView mounts one per document; a field reads the result.
 */
export const FieldMarksProvider: React.FC<{
  content: { marks?: FieldMarks | null } | null | undefined;
  defaults?: ResolvedFieldMarks;
  children: React.ReactNode;
}> = ({ content, defaults = FORM_FIELD_MARKS, children }) => {
  const value = useMemo(() => resolveFieldMarks(content, defaults), [content, defaults]);
  return <FieldMarksContext.Provider value={value}>{children}</FieldMarksContext.Provider>;
};

export const useFieldMarks = (): ResolvedFieldMarks => useContext(FieldMarksContext);
